import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';
import MultiHalfText from '../../../components/MultiHalfText';

export default function Page04({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<MultiHalfText first='Bottom Heavy / Core' second='Workout 02' mt={true} />
			<RoundScreen
				isNumbered={false}
				rounds={[
					[
						{
							header: '(A) Quads/Glutes',
							value: 'Jump Squat',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 12',
						},
						{
							header: 'ABS / Core',
							value: '6 inches',
						},
						{
							header: 'Sec / Minutes',
							value: '1 min',
						},
					],
					[
						{
							header: '(A) Quads/Glutes',
							value: 'Knee Strikes',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Leg - Lifts',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Quads/Glutes',
							value: 'Curtsey Lunges',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Plank',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Quads/Glutes',
							value: 'Side Lunges',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Butterflies',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Quads/Glutes',
							value: 'Calf Raises',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 15',
						},
						{
							header: 'ABS / Core',
							value: '6 inches',
						},
						{
							header: 'Sec / Minutes',
							value: '1 min',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
